import { render, staticRenderFns } from "./CreateTaxObligationModal.vue?vue&type=template&id=7667dcec&"
import script from "./CreateTaxObligationModal.vue?vue&type=script&lang=ts&"
export * from "./CreateTaxObligationModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports